import React from 'react';

import { MapTo } from '@adobe/aem-react-editable-components';
import downloadImg from 'assets/pics/icon-download-18-x-18.svg';
import PropTypes from 'prop-types';

import { SubTitle } from 'components/SubTitle/SubTitle';

import { getSanitzedAttachmentUrl } from 'utils/UrlUtil';

import './PdfCard.scss';

export const PdfCard = ({ attachments }) => {
  const pdfAttachments = attachments.map((el, key) => {
    // eslint-disable-next-line
    const attach = el.attachment.substr(el.attachment.lastIndexOf('/') + 1);
    return (
      <div className="pdfs__links" key={key}>
        <a
          key={key}
          href={getSanitzedAttachmentUrl(el.attachment)}
          download
          rel="noopener noreferrer">
          <i>
            <img alt="Downloads" src={downloadImg} className="pdfs__image" />
          </i>
          {attach}
        </a>
      </div>
    );
  });

  return (
    attachments && (
      <div className="pdfs">
        <SubTitle text="Downloads" notFramed />
        {pdfAttachments}
      </div>
    )
  );
};

MapTo('e-fix/components/content/attachments')(PdfCard);

PdfCard.propTypes = {
  attachments: PropTypes.array.isRequired,
};
